import { Injectable } from '@angular/core';
import { RestProvider } from './rest.service';
import { environment } from '../../environments/environment';
import { Observable, ReplaySubject } from 'rxjs';
import { CustomerUtilisationRegions, DepartmentHierarchy, IDepartmentHierarchy, IDepartmentRegion, IDepartmentRegionDepot, IDepartmentRegionSimple, IDepot, INavDataExtended, UserDepartmentResponse } from '../models/depart-region-depot.model';
import { IINavData } from '../layout/default-layout/_nav';
import { IQueryFilterOptions, IQueryFilterRange } from '../models/vehicle-status.model';
import { IQueryParameters } from '../models/api-base-actions.interface';



@Injectable({
  providedIn: 'root'
})

export class GlobalDataService {
  private baseApiUrl = environment.dataliveApiUrl;

  private departmentData = new ReplaySubject<INavDataExtended[]>(1);

  private selectedDataParams = new ReplaySubject<ISelectedDataParams>(1);
  departmentHierarchy: DepartmentHierarchy | null = null;
  private departmentHierarchySubject = new ReplaySubject<DepartmentHierarchy>();
  departmentHierarchyObservable = this.departmentHierarchySubject.asObservable()

  utilisationRegions: CustomerUtilisationRegions | null = null;

  constructor(private rest: RestProvider) {
    this.initDepartmentData();
  }

  generateApiQueryParams(filterOptions: IQueryFilterOptions) {
    const _params: IQueryParameters = {};
    const todaysDate = new Date();
    const todaysDateNumber = String(todaysDate.getDate()).padStart(2, '0'); // Add leading 0 to days
    const year = todaysDate.getFullYear();
    const month = String(todaysDate.getMonth()+1).padStart(2, '0'); // Add leading 0 to months
    const formatDate = (year: number, month: number, day: number) => {
      const formattedMonth = String(month).padStart(2, '0');
      const formattedDay = String(day).padStart(2, '0');
      return `${year}-${formattedMonth}-${formattedDay}`;
    };

    if (filterOptions?.range === IQueryFilterRange.ThisYear) {
      _params["date_start"] = `${year}-01-01`;
      _params["date_end"] = `${year}-12-31`;
      _params["snapshot_date_start"] = `${year}-01-01`;
      _params["snapshot_date_end"] = `${year}-12-31`;
    } else if (filterOptions?.range === IQueryFilterRange.ThisMonth) {
      const howManyDaysInMonth = new Date(year, parseInt(month), 0).getDate();
      _params["date_start"] = formatDate(year, parseInt(month), 1);
      _params["date_end"] = formatDate(year, parseInt(month), howManyDaysInMonth);
      _params["snapshot_date_start"] = formatDate(year, parseInt(month), 1);
      _params["snapshot_date_end"] = formatDate(year, parseInt(month), howManyDaysInMonth);
    } else if (filterOptions?.range === IQueryFilterRange.PrevMonth) {
      const prevMonth = parseInt(month) - 1 || 12;
      const prevMonthYear = prevMonth === 12 ? year - 1 : year;
      const howManyDaysInPrevMonth = new Date(prevMonthYear, prevMonth, 0).getDate();
      _params["date_start"] = formatDate(prevMonthYear, prevMonth, 1);
      _params["date_end"] = formatDate(prevMonthYear, prevMonth, howManyDaysInPrevMonth);
      _params["snapshot_date_start"] =formatDate(prevMonthYear, prevMonth, 1);
      _params["snapshot_date_end"] = formatDate(prevMonthYear, prevMonth, howManyDaysInPrevMonth);
    } else if (filterOptions?.range === IQueryFilterRange.Today) {
      _params["date_start"] = formatDate(year, parseInt(month), parseInt(todaysDateNumber));
      _params["date_end"] = _params["date_start"];
      _params["snapshot_start_date"] = formatDate(year, parseInt(month), parseInt(todaysDateNumber));
      _params["snapshot_date_end"] = _params["snapshot_start_date"];
    } else if (filterOptions?.range === IQueryFilterRange.Yesterday) {
      _params["date_start"] = formatDate(year, parseInt(month), parseInt(todaysDateNumber) - 1);
      _params["date_end"] = formatDate(year, parseInt(month), parseInt(todaysDateNumber));
      _params["snapshot_start_date"] = formatDate(year, parseInt(month), parseInt(todaysDateNumber));
      _params["snapshot_date_end"] = formatDate(year, parseInt(month), parseInt(todaysDateNumber));
    } else if (filterOptions?.range === IQueryFilterRange.ThisWeek) {
      const currentDay = todaysDate.getDay(); // Sunday = 0, Monday = 1, ..., Saturday = 6
      const startOfWeek = new Date(todaysDate);
      const endOfWeek = new Date(todaysDate);

      // Set start to last Monday
      startOfWeek.setDate(todaysDate.getDate() - (currentDay - 1));
      // Set end to next Sunday
      endOfWeek.setDate(todaysDate.getDate() + (7 - currentDay));

      _params["date_start"] = formatDate(year, parseInt(month), startOfWeek.getDate());
      _params["date_end"] = formatDate(year, parseInt(month), endOfWeek.getDate());

      console.log(_params)
    } else {
      // defaults to year
      _params["date_start"] = `${year}-01-01`;
      _params["date_end"] = `${year}-12-31`;
    }

    return _params;
  }

  initSelectedDataParams() {
    const params: ISelectedDataParams = {
      selectedDateStart: null,
      selectedDateEnd: null,
      selectedDateRangeName: 'TODAY',
      selectedDepartment: null,
      selectedRegion: null,
      selectedDepot: null,
      selectedVehicleType: null,
      selectedFuelType: null
    }
    this.selectedDataParams.next(params);
  }

  initDepartmentData() {
    this.rest.GetUserDepartments().subscribe({
      next: (data) => {
        // console.log('GetUserDepartments: ', data);

        this.mapDepartmentRegionDepots(data);
        // Set the data to the subject
        // this.departmentData.next(data);

      },
      error: (e) => console.error(e),
      // complete: () => console.info('GetUserDepartments complete')
    })

    this.rest.GetUtilisationRegions().subscribe({
      next: (data) => {
        console.log('GetUtilisationRegions: ', data)
        // Set the data to the subject
        // this.departmentData.next(data);
        this.utilisationRegions = data;
      },
      error: (e) => console.error(e),
      // complete: () => console.info('GetUtilisationRegions complete')
    })


    //customer/utilisation-report-regions/
    // user/departments


  }

  getDepartmentData(): Observable<INavDataExtended[]> {          // <-- return observable here
    return this.departmentData.asObservable();
  }

  getSelectedDataParams(): Observable<ISelectedDataParams> {          // <-- return observable here
    return this.selectedDataParams.asObservable();
  }



  private mapDepartmentRegionDepots(departments: UserDepartmentResponse) {
    let mappedDepartments: IDepartmentHierarchy[] = [];
    departments.forEach(dept => {
      let _department: IDepartmentHierarchy = {
        id: dept.id,
        reference: dept.reference,
        name: dept.name,
        creation_datetime: dept.creation_datetime,
        regions: [],
        expected_avg_utilization_score: dept.expected_avg_utilization_score,
      }
      if (dept.regions) {
        _department.regions = this.depotToRegionParentMap(dept.regions);
      }
      mappedDepartments.push(_department)
    });
    // console.log('mapDepartmentRegionDepots: ', departments);
    this.departmentHierarchy = mappedDepartments;
    this.departmentHierarchySubject.next(this.departmentHierarchy)
    // Prepare the INavData sidebar data
    this.prepareSideNavData(this.departmentHierarchy);
  }


  private depotToRegionParentMap(rows: IDepartmentRegion[]): IDepartmentRegionSimple[] {

    const uniqueNames: any = [];
    const nameSet: any = {};

    rows.forEach(item => {
      if (!nameSet[item.name]) {
        let vgs: IDepartmentRegionDepot[] = [];
        nameSet[item.name] = true;
        rows.forEach(group => {
          if (group.id === item.id) {
            const _group = {
              id: group.VehicleGroups__id,
              name: group.VehicleGroups__name
            }
            vgs.push(_group);
          }
        });
        // item.vehicle_groups = vgs;
        const _region = {
          id: item.id,
          name: item.name,
          vehicle_groups: vgs
        }
        uniqueNames.push(_region);
      }
    });


    return uniqueNames;

  }



  private prepareSideNavData(departments: IDepartmentHierarchy[]) {
    let _navItems: INavDataExtended[] = [];

    const _dailyVehCountItem: INavDataExtended = {
      name: 'Daily Vehicle Count',
      url: '/daily-vehicle-count',
      iconComponent: { name: 'cil-calendar' },
      type: 'VEHICLE_COUNT',
      attributes: { class: 'attr', variant: '' }
    }
    const _divider: INavDataExtended = {
      name: 'Departments',
      title: true,
      iconComponent: { name: 'cil-calendar' },
      type: 'HEADING',
      attributes: { class: 'attr', variant: '' }
    }

    _navItems.push(_dailyVehCountItem);
    _navItems.push(_divider);

    departments.forEach(dept => {
      let _navItem: INavDataExtended = {
        id: dept.id,
        name: dept.name,
        url: `/department/${dept.id}`,
        linkProps: {
          state: {
            departmentName: dept.name
          }
        },
        expected_avg_utilization_score: dept.expected_avg_utilization_score,
        type: 'DEPT',
        iconComponent: { name: 'cil-chart' },
        children: []
      };
      const _navItemDeptLink: INavDataExtended = {
        id: dept.id,
        name: `Summary`,
        url: `/department/${dept.id}`,
        linkProps: {
          state: {
            departmentName: dept.name
          }
        },
        type: 'DEPT'
      };

      if (dept.regions && dept.regions.length > 0) {
        if (_navItem.children) {
          // Adding a department summary link
          _navItem.children.push(_navItemDeptLink);
        }
        for (let index = 0; index < dept.regions.length; index++) {
          const region = dept.regions[index];

          let _navItemRegionSummary: INavDataExtended = {
            id: region.id,
            name: "Region Summary",
            url: `/department/${dept.id}/region/${region.id}`,
            type: 'REGION',
            linkProps: {
              state: {
                departmentName: dept.name,
                regionName: region.name
              }
            }
          }

          let _navItemRegion: INavDataExtended = {
            id: region.id,
            name: region.name,
            url: `/department/${dept.id}/region/${region.id}`,
            linkProps: {
              state: {
                departmentName: dept.name,
                regionName: region.name
              }
            },
            type: 'REGION',
            children: [
              _navItemRegionSummary
            ]
          };

          if (region.vehicle_groups && dept.regions.length > 0) {
            for (let j = 0; j < region.vehicle_groups.length; j++) {
              const depot = region.vehicle_groups[j];
              let _navItemDepot: INavDataExtended = {
                id: depot.id,
                name: depot.name,
                url: `/department/${dept.id}/region/${region.id}/depot/${depot.id}`,
                linkProps: {
                  state: {
                    departmentName: dept.name,
                    regionName: region.name,
                    depotName: depot.name
                  }
                },
                type: 'DEPOT',
              };
              if (_navItemRegion.children) {
                _navItemRegion.children.push(_navItemDepot);
              }

            }
          }

          if (_navItem.children) {
            _navItem.children.push(_navItemRegion);
          }
        }
      }

      _navItems.push(_navItem);

    });
    this.departmentData.next(_navItems);



    const navItems: IINavData[] = [
      {
        name: 'Daily Vehicle Count',
        url: '/daily-vehicle-count',
        iconComponent: { name: 'cil-calendar' },
        type: 'VEHICLE_COUNT'
      },
      {
        name: 'Network Dept',
        url: '/department/1',
        type: 'DEPT',
        iconComponent: { name: 'cil-chart' },
        children: [
          {
            name: 'Network Dept Summary',
            url: '/department/1',
            type: 'DEPT'
          },
          {
            name: 'Region 1',
            url: '/region/25',
            iconComponent: { name: 'cil-compress' },
            type: 'REGION',
            children: [
              {
                name: 'DPD Durham',
                url: '/depot/100',
                icon: 'nav-icon-bullet',
                type: 'DEPOT',
              },
              {
                name: 'DPD Guildford',
                url: '/depot/222',
                icon: 'nav-icon-bullet',
                type: 'DEPOT',
              },
              {
                name: 'DPD Southampton',
                url: '/depot/126',
                icon: 'nav-icon-bullet',
                type: 'DEPOT',
              },
              {
                name: 'DPD Bouremouth',
                url: '/depot/89',
                icon: 'nav-icon-bullet',
                type: 'DEPOT',
              },
            ]
          },
          {
            name: 'Region 2',
            url: '/region/6',
            iconComponent: { name: 'cil-compress' },
            type: 'REGION',
            children: [
              {
                name: 'DPD Aberdeen',
                url: '/depot/86',
                icon: 'nav-icon-bullet',
                type: 'DEPOT',
              },
              {
                name: 'DPD Abergele',
                url: '/region/202',
                icon: 'nav-icon-bullet',
                type: 'DEPOT',
              },
              {
                name: 'DPD Barking',
                url: '/region/189',
                icon: 'nav-icon-bullet',
                type: 'DEPOT',
              },
            ]
          }

        ]
      },
      {
        name: 'Transport Dept',
        url: '/department/2',
        type: 'DEPT',
        iconComponent: { name: 'cil-chart' },
        children: [
          {
            name: 'Transport Dept Summary',
            url: '/department/2',
            type: 'DEPT',
            icon: 'nav-icon-bullet',
          },
          {
            name: 'Region 3',
            url: '/region/7',
            icon: 'nav-icon-bullet',
            type: 'REGION',
            children: [
              {
                name: 'DPD Bicester',
                url: '/depot/222',
                icon: 'nav-icon-bullet',
                type: 'DEPOT',
              },
              {
                name: 'DPD Southampton',
                url: '/depot/126',
                icon: 'nav-icon-bullet',
                type: 'DEPOT',
              }
            ]
          }

        ]
      }

    ]
  }
}


export interface ISelectedDataParams {
  selectedDateStart: string | null,
  selectedDateEnd: string | null,
  selectedDateRangeName: 'TODAY' | 'THIS_WEEK' | 'THIS_MONTH',
  selectedDepartment: IDepot | null,
  selectedRegion: IDepot | null | '',
  selectedDepot: IDepot | null | ''
  selectedVehicleType: null,
  selectedFuelType: null
}
